/**
 * "Add to calendar" for a meeting (1.13.0, Teampace 2709): Google Calendar's and Outlook's own
 * pages, filled in with the meeting's name, time and link (the person saves it there), and the .ics
 * file for everything else. Nothing is sent anywhere until they choose one.
 */

export interface CalendarMeeting {
  title: string;
  startsAt: string;
  endsAt: string;
  link: string;
  company?: string;
}

const describe = (m: CalendarMeeting) => `${m.company ? `A meeting with ${m.company}.\n\n` : ''}Join: ${m.link}\n\nOpen the link in any browser.`;

/** 20261102T150000Z */
const compact = (iso: string) => new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

export function googleCalendarLink(m: CalendarMeeting): string {
  const q = new URLSearchParams({ action: 'TEMPLATE', text: m.title, dates: `${compact(m.startsAt)}/${compact(m.endsAt)}`, details: describe(m), location: m.link });
  return `https://calendar.google.com/calendar/render?${q.toString()}`;
}

/** Outlook on the web: work or school accounts (outlook.office.com), or personal ones (outlook.live.com). */
export function outlookCalendarLink(m: CalendarMeeting, personal = false): string {
  const q = new URLSearchParams({ path: '/calendar/action/compose', rru: 'addevent', subject: m.title, startdt: new Date(m.startsAt).toISOString(), enddt: new Date(m.endsAt).toISOString(), body: describe(m), location: m.link });
  return `https://outlook.${personal ? 'live' : 'office'}.com/calendar/0/action/compose?${q.toString()}`;
}
